export default "__VITE_ASSET__C$vT$YX___"